import { AppOrientation } from '@/lostHooks/orientation/useOrientation';
import '@/game-client/styles/index.scss';
import { Dispatch, SetStateAction } from 'react';
import { ClientPlaceholderType } from '@/game-client/types';
import LoadingScreen from '@/features/LoadingScreen/LoadingScreen';
import { PokerLoadingScreen } from '@/features/LoadingScreen/PokerLoadingScreen';
import { useStore } from '@/store/useStore';
import { PRODUCTS } from '@/utilities/constants/game';

export const GameClientPlaceholder = ({
  type,
  isStuckedLoading,
  setLoadingAnimationFinished,
  themeData,
  orientation,
}: GameClientPlaceholderProps) => {
  const product = useStore((s) => s.runtime.product)?.toLowerCase();
  const isAndroid = useStore((s) => s.runtime.wrapperType.isAndroid);
  if (type === 'none') return null;

  const isPokerLoader =
    product === PRODUCTS.POKER ||
    themeData?.data?.loading_theme?.toLowerCase() === 'translate in';

  return (
    <div className={`game-client_placeholder ${type}`}>
      {isPokerLoader ? (
        <PokerLoadingScreen
          type={type}
          isStuckedLoading={isStuckedLoading}
          onAnimationFinish={() => setLoadingAnimationFinished(true)}
        />
      ) : (
        <LoadingScreen
          themeData={themeData}
          isStuckedLoading={isStuckedLoading}
          orientation={orientation}
          isAndroid={isAndroid}
          setLoadingAnimationFinished={setLoadingAnimationFinished}
          type={type}
        />
      )}
    </div>
  );
};

interface ThemeData {
  data?: {
    loading_theme?: string;
    body?: [
      {
        items?: [
          {
            is_bottom_banner?: boolean;
          },
        ];
      },
    ];
  };
  is_bottom_banner?: boolean;
  loader_img?: string;
  oompa_loompa?: { url: string };
  is_bottom?: boolean;
  background_landscape?: { url: string };
  icon?: { url: string };
}

type GameClientPlaceholderProps = {
  type: ClientPlaceholderType;
  isStuckedLoading: boolean;
  loadingAnimationFinished: boolean;
  setLoadingAnimationFinished: Dispatch<SetStateAction<boolean>>;
  orientation?: AppOrientation;
  themeData?: ThemeData;
};
